import { render, staticRenderFns } from "./CompanyAPI.vue?vue&type=template&id=4c7140e4&scoped=true&"
import script from "./CompanyAPI.vue?vue&type=script&lang=js&"
export * from "./CompanyAPI.vue?vue&type=script&lang=js&"
import style0 from "./CompanyAPI.vue?vue&type=style&index=0&id=4c7140e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7140e4",
  null
  
)

export default component.exports